import { graphql } from "../../../models/autogenerated-deliveryService-gql";

export const CancelTimeSlotMutation = graphql(/* GraphQL */ `
  mutation cancelTimeSlot($cancelTimeSlotInput: CancelTimeSlotInput!) {
    cancelTimeSlot(input: $cancelTimeSlotInput) {
      successOutput {
        ...SuccessOutput
      }
    }
  }
`);
